module.exports = __webpack_public_path__ + "static/16-5fa7b3b5e000b2832ff5ef50bbf12a34.jpg";